import { createSelector } from 'reselect';

import { getState as getParent } from 'modules/notifications/selectors';

export const getState = createSelector(getParent, ({ ui } = {}) => ui);

/** @returns {boolean} */
export const isFetching = createSelector(getState, ({ isFetchingMarkAllRead }) => isFetchingMarkAllRead ?? false);

/** @returns {boolean} */
export const isOpenPermissionModal = createSelector(
  getState,
  ({ isPermissionModalOpen }) => isPermissionModalOpen ?? false
);
